import QueryString from "query-string";
import { ASSET_CLASS, REGIONS } from "../../redux/slices/api/initialisePreferences";
import { getQueryString } from "../search/api/filterUrlMaker";
import { getState } from "../../app/StoreFactory";

export const prefsToMyResearchUrl = () => {
  const preferences = getState().preferences;

  let qs = getQueryString();
  qs["Asset Class"] = preferences[ASSET_CLASS];
  qs["Regions"] = preferences[REGIONS];

  return "/My_Research?" + QueryString.stringify(qs);
};
